 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Policy
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPolicyFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.polNo"
                            :label="filtersPolicyLabel.polNo"
                            :error-messages="errors.collect('filterPolicy')"
                            data-vv-name="filterPolicy"
                            :data-vv-as="filtersPolicyLabel.policy"
                            v-validate="'entry|max:20|min_char:3'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.renCnt"
                            :label="filtersPolicyLabel.renCnt"
                            :error-messages="errors.collect('filterPolicy')"
                            data-vv-name="filterPolicy"
                            :data-vv-as="filtersPolicyLabel.renCnt"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.endtCnt"
                            :label="filtersPolicyLabel.endtCnt"
                            :error-messages="errors.collect('filterPolicy')"
                            data-vv-name="filterPolicy"
                            :data-vv-as="filtersPolicyLabel.endtCnt"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPolicyFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPolicyFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="this.polHeader === 'polHeader2'">
        <v-data-table
          :headers="polHeaders2"
          :items="polItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td>{{ row.item.insdName1 }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-else>
        <v-data-table
          :headers="polHeaders"
          :items="polItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td>{{ row.item.endtCnt }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersPolicyLabel: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        endtCnt: 'Endorsement Count'
      },
      filtersPolicy: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined
      },
      actionName: '',
      polItems: [],
      totalItemsPol: 0,
      polHeaders: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Renewal Count', value: 'renCnt' },
        { text: 'Endorsement Count', value: 'endtCnt' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearPolicyFilters()
  },
  created() {
    this.fetchPolicyData()
  },
  methods: {
    closeDialog() {
      this.filtersPolicy.polNo = ''
      this.filtersPolicy.renCnt = ''
      this.filtersPolicy.endtCnt = ''
      this.$emit('close')
    },
    doClearPolicyFilters() {
      this.filtersPolicy.polNo = ''
      this.filtersPolicy.renCnt = ''
      this.filtersPolicy.endtCnt = ''
      this.fetchPolicyData()
    },
    doPolicyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolicyFilterForm').then((result) => {
        if (result) {
          // this.paginationPolicy.page = 1
          this.fetchPolicyData()
        }
      })
    },
    assignPolicy(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-policy', data)
      this.$emit('close')
    },
    async fetchPolicyData() {
      const apiUrl = this.apiURI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationPolicy
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filtersPolicy)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationPolicy.sortBy, this.paginationPolicy.sortDesc)
          )
          if (result.data) {
            this.totalItemsPol = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.polItems = data
            } else {
              this.polItems = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearPolicyFilters()
      }
    },
    paginationPolicy: function (value) {
      this.fetchPolicyData()
    }
  },
  computed: {},
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin],
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    polHeader: {
      type: String,
      default: ''
    },
    apiURI: {
      type: String,
      required: true
    }
  }
}
</script>
